import state from './fileState'
import mutations from './fileMutations'
import getters from './fileGetters'
import actions from './fileActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
